import {
  MUTATION_ADD_C2C_VEHICLE,
  MUTATION_CONTACT_C2C,
  MUTATION_DELETE_C2C_VEHICLE,
  QueryGarageVehicles,
  SchemaTypes,
} from '@allesauto/graphql';
import { useMutation } from '@apollo/client';

import { useAuthorizationHeader } from './useAuthorizationHeader';
import { IDataMutationResponse } from '../models/IDataMutationResponse';

interface IAddC2CResponse extends IDataMutationResponse {
  addC2cVehicle: (
    input: SchemaTypes.C2cVehicleInput
  ) => Promise<SchemaTypes.C2cVehicleResponse | null | undefined>;
}

export const useC2cAddVehicle = (): IAddC2CResponse => {
  const authorizationHeader = useAuthorizationHeader();

  const [mutationAddC2cVehicle, { loading, error }] =
    useMutation<SchemaTypes.C2cVehicleResponse>(MUTATION_ADD_C2C_VEHICLE, {
      context: authorizationHeader,
    });

  const addC2cVehicle = async (input: SchemaTypes.C2cVehicleInput) => {
    const { data } = await mutationAddC2cVehicle({
      variables: {
        input,
      },
    });

    return data;
  };

  return {
    addC2cVehicle,
    loading,
    error,
  };
};

interface IDeleteC2CResponse extends IDataMutationResponse {
  deleteC2cVehicle: (c2cId: string) => Promise<boolean>;
}

export const useC2cDeleteVehicle = (): IDeleteC2CResponse => {
  const authorizationHeader = useAuthorizationHeader();

  const [mutationDeleteC2cVehicle, { loading, error }] = useMutation<
    Pick<SchemaTypes.Mutation, 'deleteC2cVehicle'>
  >(MUTATION_DELETE_C2C_VEHICLE, { context: authorizationHeader });

  const deleteC2cVehicle = async (c2cId: string) => {
    const { data } = await mutationDeleteC2cVehicle({
      variables: {
        c2cId,
      },
      refetchQueries: [
        { query: QueryGarageVehicles, context: authorizationHeader },
      ],
    });

    return data?.deleteC2cVehicle ?? false;
  };

  return {
    deleteC2cVehicle,
    loading,
    error,
  };
};

interface IContactC2CResponse extends IDataMutationResponse {
  contactC2c: (
    c2cId: string,
    input: SchemaTypes.C2cContactInput
  ) => Promise<boolean>;
}

export const useC2cContact = (): IContactC2CResponse => {
  const authorizationHeader = useAuthorizationHeader();

  const [mutationContactC2c, { loading, error }] = useMutation<
    Pick<SchemaTypes.Mutation, 'contactC2c'>
  >(MUTATION_CONTACT_C2C, { context: authorizationHeader });

  const contactC2c = async (
    c2cId: string,
    input: SchemaTypes.C2cContactInput
  ) => {
    const { data } = await mutationContactC2c({
      variables: {
        c2cId,
        input,
      },
    });

    return data?.contactC2c ?? false;
  };

  return {
    contactC2c,
    loading,
    error,
  };
};
